export default __webpack_public_path__ + "static/media/icon-logo.2502e733.svg";